import { useTranslation } from 'react-i18next';
import { Details, Heading, Paragraph } from '@digdir/designsystemet-react';
import type { RoleInfo } from '../../../../utils/RolesUtils';
import classes from '../Users.module.css';

/** «Hva gir de ulike rollene tilgang til?» */
export const RoleGuide = ({ roles }: { roles: RoleInfo[] }) => {
  const { t } = useTranslation();
  return (
    <section aria-labelledby="role-guide-heading" className={classes.card}>
      <Heading id="role-guide-heading" level={2} data-size="xs">
        {t('organizationPage.users.roleGuide')}
      </Heading>
      <div className={classes.guide}>
        {roles.map((role) => (
          <Details key={role.key}>
            <Details.Summary>{role.label}</Details.Summary>
            <Details.Content>
              <Paragraph>{role.description}</Paragraph>
            </Details.Content>
          </Details>
        ))}
      </div>
    </section>
  );
};
